import React from 'react';
import InformationCircleIcon from '@atlaskit/icon/core/information-circle';
import { Inline, Text, Anchor } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { messages } from './messages.tsx';

const styles = cssMap({
	aiDisclaimer: {
		color: token('color.text.subtlest'),
	},
	aiDisclaimerLink: {
		textDecoration: 'none',
		'&:hover': {
			textDecoration: 'none',
		},
		'&:visited': {
			textDecoration: 'none',
		},
	},
});

export const UsesAIVerifyResults = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { formatMessage } = useIntl();

	const handlePrivacyAndLegalClicked = () => {
		const analyticsEvent = createAnalyticsEvent({
			action: 'clicked',
			actionSubject: 'link',
		});
		fireUIAnalytics(analyticsEvent, 'jqlBuilderAiPrivacyAndLegal');
	};
	return (
		<Inline space="space.050" alignBlock="center" grow="fill" xcss={styles.aiDisclaimer}>
			<InformationCircleIcon label="" size="medium" />
			<Anchor
				xcss={styles.aiDisclaimerLink}
				target="_blank"
				href="https://www.atlassian.com/trust/atlassian-intelligence"
				onClick={handlePrivacyAndLegalClicked}
			>
				<Text size="small">{formatMessage(messages.usesAiVerifyResults)}</Text>
			</Anchor>
		</Inline>
	);
};
